import React, {Fragment} from "react";
import { Ticket, TicketStatus, TicketType, TicketChannel, TicketSubtype, TicketGroup} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {RouteComponentProps, withRouter} from "react-router";
import {LoadingViewState, RouterView} from "../RouterView";
import {TicketService} from "../../services/TicketService";
import { FormSubmitError, FormSubmitSuccess } from "../form/FormFeedback";
import { Form, FormListener } from "../form/Form";
import { FormGroup } from "../form/FormGroup";
import { SelectInput } from "../form/SelectInput";
import { Submit } from "../form/Submit";
import { FormInput, FormInputList, StaticFormValue } from "../form/FormInput";
import { Validators } from "../form/Validators";
import { FormTextArea } from "../form/FormTextArea";

interface State extends LoadingViewState {
    ticket?: Ticket;
    validationMap? : any;
}

interface Props extends RouteComponentProps {

}

export class TicketCreate extends RouterView<Props, State> implements FormListener<Ticket>{

    service: TicketService;
    constructor(props : Props){
        super(props);
        this.service = getContainer().getTicketService();
        this.state = { ticket: { subtype:TicketSubtype.GENERAL_INFORMATION}, validationMap: {}, loading: true};
    }

    loadContent() : void{

    }

    onSubmit(): Promise<any> | undefined {
        if(!this.state.ticket) return;
        return this.service.save(this.state.ticket).then((tic: Ticket) => {
                this.setState({ ticket: tic });
                this.props.history.push("/ticket/"+ tic.id)
        })
          
    }

    async onListSubmit(request: Ticket) : Promise<any> {
        if (!request) return;
        const ticket = await this.service.save(request)
        return "Ticket id " + ticket.id + " was saved.";
    }

    formDidUpdate(formModel: Ticket, validationMap?: any) {
        this.setState({ticket : formModel, validationMap : validationMap})
    }

    getTitle() : string {
        return "Ticket Create";
    }

    getType(){
        if(this.state.ticket!==undefined){
            if(this.state.ticket.type!==undefined){
                return this.state.ticket.type;
            }
        }
    }

    getSubtypeByType(type:TicketType| undefined){
        if (type === undefined) return [];
        let result : TicketSubtype[] = this.service.getSubtypeByType(type) || [];
        if(this.state.ticket!==undefined && result.length > 0){
            this.state.ticket.subtype = result[0];
        }
        return result;
    }

    renderContent() {
        return (
            <Fragment>
                <div className="row">
                    <div className={"col-lg-12"}>
                        <div className={"row"}>
                            <div className="col-lg-12">
                                <Form listInput="requested_by" listInputService={this.onListSubmit.bind(this)} className="form form-horizontal" validationMap={this.state.validationMap} modelObject={this.state.ticket} formListener={this}>
                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Ticket status was updated successfully" />
                                    <StaticFormValue model="channel" value={TicketChannel.WEBFORM} />
                                <div className={"card-box"}>
                                    <div className="ibox-content">
                                    <table className={"table table-striped"}>
                                        <tbody>
                                        <tr>
                                            <td>User ID:</td>
                                            <td>
                                            <FormGroup className="form-group mb-3">
                                                <FormInputList className="form-control" model="requested_by" type="text"  validators={[Validators.required()]}/>
                                            </FormGroup>
                                            
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Subject:</td>
                                            <td>
                                            <FormGroup className="form-group mb-3">
                                                <FormInput className="form-control" model="subject" type="text" validators={[Validators.required()]}/>
                                            </FormGroup>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Issue Type:</td>
                                            <td>
                                            <FormGroup className="form-group">
                                                <SelectInput name="type" className="form-control" model="type" values={Object.keys(TicketType)} validators={[Validators.required()]}/>
                                            </FormGroup>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Issue Subtype:</td>
                                            <td>
                                            <FormGroup className="form-group">
                                                <SelectInput name="subtype" className="form-control" model="subtype" values={this.getSubtypeByType(this.getType())} validators={[Validators.required()]}/>
                                            </FormGroup>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Status:</td>
                                            <td>
                                                <FormGroup className="form-group">
                                                    <SelectInput name="status" className="form-control" model="status" values={Object.keys(TicketStatus)} validators={[Validators.required()]}/>
                                                </FormGroup>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Assigned:</td>
                                            <td>
                                                <FormGroup className="form-group">
                                                    <SelectInput name="groups" className="form-control" model="groups" multiple={true} values={Object.keys(TicketGroup)} validators={[Validators.required()]} />
                                                </FormGroup>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Message:</td>
                                            <td>
                                                <FormGroup className="form-group" >
                                                    <FormTextArea className="form-control" model="text" type="text" validators={[Validators.required()]}/>
                                                </FormGroup>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div className="col-lg-6">
                                        <Submit className="btn  btn-primary">Submit</Submit>
                                    </div>
                                    </div>
                                </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

}

export default withRouter(TicketCreate);

